/* eslint-disable */
import React, { useMemo, useEffect, useState } from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { Dayjs } from "dayjs";
import StatCard from "../LayoutComponents/StatCard";

import FastAPIClient from "../../client";
import config from "../../config";
const client = new FastAPIClient(config);

type MeetingLog = {
    user_id: string;
    first_name: string;
    last_name: string;
    date: string;
    meeting_type: string;
    meeting_type_description: string;
    team_name: string;
    warehouse_name: string;
    meeting_count: number;
};

interface MeetingTypeChartProps {
    selectedUser: string;
    selectedTeam: string;
    selectedWarehouse: string;
    dateRange: string;
}

type UserInfo = {
    user_id: string;
    first_name: string;
    last_name: string;
    warehouse_name: string;
    team_name: string;
    user_role_description: string;
};

const roleTranslations: Record<string, string> = {
    sales_rep: "Représentant commercial",
    sales_manager: "Chef des ventes",
    supervisor: "Superviseur",
    management: "Management",
};

const UserTypesChart: React.FC<MeetingTypeChartProps> = ({
    selectedUser,
    selectedTeam,
    selectedWarehouse,
    dateRange,
}) => {
    const [data, setData] = useState<UserInfo[] | null>(null);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await client.fetchUserTypes(); // ← API call
            console.log("users", response.results);
            setData(response.results);
        } catch (error) {
            console.error("Error fetching user types:", error);
        }
    };

    const filteredData = useMemo(() => {
        if (!data) return [];

        return data.filter((user) => {
            const matchUser =
                selectedUser === "all" ||
                `${user.first_name} ${user.last_name}` === selectedUser;
            const matchTeam =
                selectedTeam === "all" || user.team_name === selectedTeam;
            const matchWarehouse =
                selectedWarehouse === "all" ||
                user.warehouse_name === selectedWarehouse;

            return matchUser && matchTeam && matchWarehouse;
        });
    }, [data, selectedUser, selectedTeam, selectedWarehouse]);

    const chartData = useMemo(() => {
        const roleCounts: Record<string, number> = {};

        filteredData.forEach((user) => {
            const roleLabel =
                roleTranslations[user.user_role_description] ||
                user.user_role_description;

            roleCounts[roleLabel] = (roleCounts[roleLabel] || 0) + 1;
        });

        return {
            labels: Object.keys(roleCounts),
            values: Object.values(roleCounts),
        };
    }, [filteredData]);

    if (!data) {
        return <Typography>Chargement...</Typography>;
    }

    return (
        <StatCard
            title="Utilisateurs par rôle"
            value={""}
            subtitle=""
            loading={!data}
        >
            <BarChart
                xAxis={[{ scaleType: "band", data: chartData.labels }]}
                series={[{ data: chartData.values }]}
                height={200}
                borderRadius={10}
                grid={{ vertical: false }}
                margin={{ top: 10, left: 0, right: 0, bottom: 0 }}
                barLabel={(params) => `${params.value}`}
                sx={{
                    "& .MuiChartsAxis-bottom .MuiChartsAxis-line": {
                        display: "none",
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-line": {
                        display: "none",
                    },
                    "& .MuiChartsAxis-tickLabel span:first-of-type": {
                        fontWeight: "bold",
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
                        fill: "#000000",
                        fontSize: 12,
                        fontFamily: "Roboto",
                        display: "none", // Hides Y-axis labels
                    },
                    "& .MuiChartsAxis-bottom .MuiChartsAxis-tick": {
                        display: "none",
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tick": {
                        display: "none", // Already hiding the Y-axis ticks, keeping it here to ensure it works
                    },
                }}
            />
        </StatCard>
    );
};

export default UserTypesChart;
